/** テレビデモで表示する全計測地点（ダッシュボードと同じ id） */
import { getLocationLabel } from '../i18n';
import { TV_SPOT_LOCATION_OPTIONS } from './tvSpotLocation';

export const TV_FOCUS_LOCATION_IDS = [
  'old-town',
  'station',
  'gyouzinbashi',
  'omotesando',
  'yottekan',
  'honmachi4',
  'honmachi3',
  'honmachi2',
  'kokubunjidori',
  'yasukawadori',
  'jinnya',
  'nakabashi',
];

export const TV_DEMO_DEFAULT_LOCATION = 'honmachi4';

/** 画面6「先週の流れ」に載せる主要4エリア */
export const TV_PAST_WEEK_LOCATION_IDS = [
  'station',
  'old-town',
  'honmachi4',
  'gyouzinbashi',
];

export function getTvPastWeekLocationLabel(locationId, language = 'ja') {
  const spot = TV_SPOT_LOCATION_OPTIONS.find((o) => o.id === locationId);
  if (spot) return spot.label;
  return getLocationLabel(locationId, language);
}

/** @deprecated TV_FOCUS_LOCATION_IDS を使用 */
export const TV_DEMO_LOCATIONS = TV_FOCUS_LOCATION_IDS.map((id) => ({ id }));
